import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  CreateMarketingCampaignPayload,
  MarketingCampaign
} from "../../marketing.types";

export const requestCreateMarketingCampaign = async (
  payload: CreateMarketingCampaignPayload
): Promise<MarketingCampaign> => {
  return await instance.post(ApiRoutesMarketing.Campaigns, payload);
};
